// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskTradePartnerContentMetadataQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TradePartnerFilter>;
}>;


export type TaskTradePartnerContentMetadataQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }> };


export const TaskTradePartnerContentMetadataDocument = gql`
    query TaskTradePartnerContentMetadata($filter: TradePartnerFilter) {
  tradePartners(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useTaskTradePartnerContentMetadataQuery__
 *
 * To run a query within a React component, call `useTaskTradePartnerContentMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTradePartnerContentMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTradePartnerContentMetadataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTaskTradePartnerContentMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>(TaskTradePartnerContentMetadataDocument, options);
      }
export function useTaskTradePartnerContentMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>(TaskTradePartnerContentMetadataDocument, options);
        }
export function useTaskTradePartnerContentMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>(TaskTradePartnerContentMetadataDocument, options);
        }
export type TaskTradePartnerContentMetadataQueryHookResult = ReturnType<typeof useTaskTradePartnerContentMetadataQuery>;
export type TaskTradePartnerContentMetadataLazyQueryHookResult = ReturnType<typeof useTaskTradePartnerContentMetadataLazyQuery>;
export type TaskTradePartnerContentMetadataSuspenseQueryHookResult = ReturnType<typeof useTaskTradePartnerContentMetadataSuspenseQuery>;
export type TaskTradePartnerContentMetadataQueryResult = Apollo.QueryResult<TaskTradePartnerContentMetadataQuery, TaskTradePartnerContentMetadataQueryVariables>;